import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Local files
import { setDefaultOptions } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';
import FR from './locales/fr.json';
import EN from './locales/en.json';

const resources = {
  fr: { translation: FR },
  en: { translation: EN },
};

const lng = new URLSearchParams(window.location.search).get('lng') || navigator?.language?.split('-')[0];

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng,
    fallbackLng: 'fr',
    debug: false, // set to true if you need to debug
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;

setDefaultOptions({ locale: i18n.language === 'fr' ? fr : enUS });
